/** Short messages in the corner, read out by screen readers through a polite live region. */
import { icon } from "./icons.ts";

let host: HTMLElement | null = null;

function region(): HTMLElement {
  if (host && document.body.contains(host)) return host;
  host = document.createElement("div");
  host.className = "toasts";
  host.setAttribute("role", "status");
  host.setAttribute("aria-live", "polite");
  document.body.append(host);
  return host;
}

export function toast(message: string, kind: "ok" | "bad" = "ok", ms = 4000): void {
  const t = document.createElement("div");
  t.className = `toast${kind === "bad" ? " toast-bad" : ""}`;
  t.style.setProperty("--life", `${ms}ms`);
  t.append(icon(kind === "bad" ? "close" : "katana"), document.createTextNode(message));
  region().append(t);
  setTimeout(() => {
    t.classList.add("leaving");
    setTimeout(() => t.remove(), 220);
  }, ms);
}
